import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import { pageCustomerGroup } from '~/lib/tealium/lookups';

const getCommonData = (state) => {
  const lang = isEmpty(get(state, 'displayData.globalData.locale')) ? 'es' : get(state, 'displayData.globalData.locale');
  const offerId = get(state, 'displayData.globalData.offerId');

  return {
    customer_group: '',
    funnel_name: 'loans: pre-approved',
    page_business_line: 'rbwm',
    page_customer_group: pageCustomerGroup[offerId],
    page_language: (lang === 'en')? 'en': `${lang.substring(0, 2)}_MX`,
    page_security_level: '30',
    product_id: '',
    site_section: 'ib',
  };
};

export default getCommonData;
